// extracted by mini-css-extract-plugin
export default {"imgContainer":"HeroImg_imgContainer__Sik7w","yong":"HeroImg_yong__vliQ4"};